import { render } from "./AlertsComponent.vue?vue&type=template&id=1bfb7561&ts=true"
import script from "./AlertsComponent.vue?vue&type=script&lang=ts"
export * from "./AlertsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__